export enum BroadCastEventEnum {
    FecharGuiaEvent = 'FecharGuiaEvent',
    RecarregarCotacaoEvent = 'RecarregarCotacaoEvent'
}
